export function getObjectValue(obj, key) {
    if (!(obj instanceof Object))
        return;
    const i = Object.keys(obj).indexOf(key);
    return Object.values(obj)[i];
}
export function Void() {
    return;
}
export function unique(val) {
    return [...new Set([...val])];
}
export function prettyJson(val) {
    try {
        return JSON.stringify(val, null, 2);
    }
    catch (e) {
        return "";
    }
}
export class EnumReader {
    $keys;
    $values;
    constructor(list) {
        this.$keys = Object.keys(list);
        this.$values = Object.values(list);
    }
    keys() {
        return [...this.$keys];
    }
    values() {
        return [...this.$values];
    }
    value(key) {
        const index = this.$keys.indexOf(key);
        return this.$values[index];
    }
    key(value) {
        const index = this.$values.indexOf(value);
        return this.$keys[index];
    }
}
